import React, { Component } from 'react';
import Card from './Layout/Card';
import '../style/OutputText.css'
import '../style/AccessibilityEnhancement.css'

export default class OutputText extends Component {
    constructor(props) {
        super(props)
        this.state = {
            inputs : this.props.inputs,
            result : this.props.response,
            cinema: false,
            coref: false,
            person: false,
            duplication: false,
            emotions: false,
            tense_not_present: false,

            features_dict: {
                "length":"Longeur",
                "duplication":"Répétition",
                "tense_notpresent": "Temps pas au présent de l’indicatif",
                "person": "1ère/2e personne",
                "cinema":"Vocabulaire cinématographique",
                "offensive" : "Vocabulaire offensant",
                "coref": "Chaîne de coréférence",
                "emotions" :"Émotions",
            },
            
            feature_color: {
                "length": "#FF7676",
                "cinema": "#E69F00",
                "coref": "#FFFF99",
                "coref_chain_id": "#DBDB6A",
                "person": "#92EC95",
                "duplication": "#CCE5FF",
                "emotions": "#CCCCFF",
                "offensive" : "#74CAB2",
                "tense_notpresent":"#FFCCE5"
            },

            coref_chain_ids: {},
            coref_chain_ids_warnings: {},
            length_ids: {},
        }

        
        this.filters = ["Longuer", "Repetition", "Temps", "Personne", "Voc. Cinéma", "Voc. offensant", "Lexique perso"];

        this.checkboxHandleInputChange = this.checkboxHandleInputChange.bind(this);
        this.paramFilterSelector = this.paramFilterSelector.bind(this);
        this.textAreaOutput = this.textAreaOutput.bind(this);
        this.downloadOuputButton = this.downloadOuputButton.bind(this);        
    }

   

    componentDidMount() {
        let featuresTestDict = {
            "length":[],
            "cinema":[],
            "coref": [],
            "coref_chain_id":[],
            "person": [],
            "duplication":[],
            "emotions" :[],
            "emotion_tokens": {},
            "tense_not_present": [],
            "tense_notpresent": [],
            "offensive":[]
        }

        let coref_chain_ids = {}
        let coref_chain_ids_warnings = {}
        let length_ids = {}

        this.state.result["documents"].forEach(doc => (
            Object.entries(doc["features"]).forEach(([feature, value]) => (
                doc["features"][feature].forEach((token) => {
         
                    if (feature === "length" ){
                        if(token['warning'] === 1){
                            let end = token['offset']['end']
                            featuresTestDict["length"].push(doc.id+"-"+(end))
                            length_ids[doc.id+"-"+(end)] = token['num_words']
                            let start = token['offset']['start']
                            let chars = end - start
                            for(var i of Array(chars).keys()){
                                var index = start+i
                                featuresTestDict[feature].push(doc.id+"-"+index)
                            }
                        }

                    }

                    else if(feature === "duplication") {
                        token.forEach((t)=> {
                            var tkn = t['token']
                            if (tkn['offset_start'] != null){
                                var start = tkn['offset_start'] + 1
                                var end = tkn['offset_end'] + 1
                                var chars = end - start
                                for(var i of Array(chars).keys()){
                                    var index = start+i
                                    featuresTestDict[feature].push(doc.id+"-"+index)
                                }
                            }
                        })
                    }
                    else if (feature === "coref") {
                        if (token['token'] !== null){
                            var tkn = token['token']

                            if (feature === "coref"){
                                if (tkn['offset_start'] != null){
                                    var start = tkn['offset_start']
                                    var end = tkn['offset_end']
                                    var chars = end - start
                                    for(var i of Array(chars).keys()){
                                        i += 1
                                        var index = start+i
                                        featuresTestDict[feature].push(doc.id+"-"+index)
                                    }
                                }

                                featuresTestDict["coref_chain_id"].push(doc.id+"-"+end)

                                if(tkn['warning'] === 1){
                                    coref_chain_ids_warnings[doc.id+"-"+end] = tkn['ref_id_chain']
                                }
                                else{
                                    coref_chain_ids[doc.id+"-"+end] = tkn['ref_id_chain']
                                }
                            }
                        }
                    }

                    else if (feature === "emotions"){
                        if (token['token'] !== null){
                            var tkn = token['token']

                            var start = tkn['offset_start']
                            var end = tkn['offset_end']
                            var chars = end - start
                            for(var i of Array(chars).keys()){
                                i += 1
                                var index = start+i
                                featuresTestDict[feature].push(doc.id+"-"+index)
                            }

                            if(tkn['warning'] === 1){
                                featuresTestDict["emotion_tokens"][doc.id+"-"+end] = tkn
                            }
                        }
                    }



                    else {
                        if (token['token'] !== null){
                            var tkn = token['token']

                            if (tkn['offset_start'] != null){
                                var start = tkn['offset_start']
                                var end = tkn['offset_end'] 
                                var chars = end - start
                                for(var i of Array(chars).keys()){
                                    i = i+1
                                    var index = start+i
                                    featuresTestDict[feature].push(doc.id+"-"+index)
                                }
                            }
                        }
                    }


                }))
            ))
        )

        this.setState({
            featuresTestDict: featuresTestDict,
            coref_chain_ids: coref_chain_ids,
            coref_chain_ids_warnings:coref_chain_ids_warnings,
            length_ids:length_ids,
        })
    }

    checkboxHandleInputChange(event) {
        const target = event.target;
        const name   = target.name;
        const value  = target.checked 

        this.setState({
            [name]:value
        })
        for(var id of this.state.featuresTestDict[name]){
            var ele = document.getElementById(id)
            if (ele != null){
                
                if(name === "coref"){
                    
                    if(ele.childNodes.length < 2){

                        let text = document.createTextNode("")
                        let span = document.createElement('span')
                        span.style.backgroundColor = !this.state[name] ? this.state.feature_color["coref_chain_id"] : "transparent"

                        if (this.state.coref_chain_ids_warnings[id] !== undefined) {
                            text.nodeValue = "("+this.state.coref_chain_ids_warnings[id]+")"

                            // Adding waring red border
                            span.style.border = !this.state[name] ? "2.5px solid" : "none";
                            span.style.borderColor = !this.state[name] ? "red" : "transparent";
                            
                        }
                        else if (this.state.coref_chain_ids[id] !== undefined){
                            text.nodeValue = "("+this.state.coref_chain_ids[id]+")"
                        }

                        span.appendChild(text)
                        ele.appendChild(span)
                    }
                    else{
                        ele.removeChild(ele.lastChild)
                    }

                    ele.style.backgroundColor =  !this.state[name] ? this.state.feature_color[name] : "transparent"

                }


                else if(name === "length"){
                    if(this.state.length_ids[id] !== undefined){
                        if(ele.childNodes.length < 2){
                            var text = document.createTextNode("("+this.state.length_ids[id]+")");
                            let span = document.createElement('span')
                            span.style.backgroundColor =  !this.state[name] ? "#F6A1A1" : "transparent"
                            span.style.border = !this.state[name] ? "2px solid" : "none";
                            span.style.borderColor = !this.state[name] ? this.state.feature_color[name] : "transparent"
                            span.appendChild(text)
                            ele.appendChild(span)
                        }
                        else{
                            ele.removeChild(ele.lastChild)
                        }
                    }   
                    else{
                        ele.style.textDecoration = !this.state[name] ? "underline":""
                        ele.style.textDecorationColor = !this.state[name] ? this.state.feature_color[name]: ""
                        ele.style.textDecorationThickness = "2px"
                    }

                }

                else if (name === "emotions") {

                    if (this.state.featuresTestDict["emotion_tokens"][id] !== undefined){
                        if(ele.childNodes.length < 2){
                            let emotion_type = this.state.featuresTestDict["emotion_tokens"][id]['type']
                            var text = document.createTextNode("(e)");
                            let span = document.createElement('span')
                            span.style.backgroundColor =  "#F6A1A1"
                            span.style.border = !this.state[name] ? "2px solid" : "none";
                            span.style.borderColor = !this.state[name] ? this.state.feature_color["length"] : "transparent"

                            span.appendChild(text)
                            ele.appendChild(span)
                        }
                        else{
                            ele.removeChild(ele.lastChild)
                        }


                    }
                    ele.style.backgroundColor =  !this.state[name] ? this.state.feature_color[name] : "transparent"

                }

                else {
                    ele.style.backgroundColor =  !this.state[name] ? this.state.feature_color[name] : "transparent"
                }
            }
        }

    }

    paramFilterSelector() { 
        return (
            <fieldset>
                <legend>Filtres d'affichage</legend>
                <div className='input-container-multi-output'>
                    {Object.entries(this.state.features_dict).map(([feature, clean_feature]) => 
                        <div className='input-container' key={feature+clean_feature}>
                            <input name={feature} type="checkbox" onChange={this.checkboxHandleInputChange} />
                            <label htmlFor={feature} style={{"backgroundColor" : this.state[feature] ? this.state.feature_color[feature] : "transparent"}} htmlFor={feature}>{clean_feature}</label> 
                        </div>
                    )}
                </div>
            </fieldset>
        )
    }

    textAreaOutput(){
        return (
            <div className='output-text'>
                {this.state.result["documents"].map(doc => (
                    <div style={{textAlign: "left"}} key={doc.id}>{
                        doc.text.split("").map((char,index) => (
                            <span 
                                id={doc.id+"-"+(index+1)}
                                key={doc.id+"-"+(index+1)}
                                style={{"marginTop":"10px"}}
                                onClick={this.dummy_func}
                                >
                                {char}
                            </span>

                        ))}
                        <span><br/></span>
                    </div>
                ))}
            </div>
        )
    }
    
    downloadOuputButton(event){

        const handleDownload = () => {
            let element = document.createElement('a');
            let outputs = {
                "inputs" : this.state.inputs,
                "output" : this.state.result
            }
            let file = new Blob([JSON.stringify(outputs, null, 2)], {type:'application/json'});
            element.href = URL.createObjectURL(file);
            element.download = 'resultat.json'
            document.body.appendChild(element);
            element.click();
        }

        return (
            <div className='buttonTéléchargement-container'>
                <button className='buttonTéléchargement' onClick={handleDownload} aria-label="Télécharger le resultat"> Télécharger </button>
            </div>
        )

    }


    render() {
        return (
            <Card title="Résultat">
                <div className='left'>
                    {this.paramFilterSelector()}
                    {this.downloadOuputButton()}
                </div>
                <div className='right'>
                    {this.textAreaOutput()}
                </div>
                <br style={{"clear":"both"}}/>
            </Card>
        )
    }
}
